<template>
    <modal name="terms-modal" class="terms-modal"
           :width="'534px'"
           :height="'669px'"
           :transition="`modal-bottom`"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
      <div class="terms_info">{{returnTermsName()}}</div>
      <div class="terms_border"> </div>
        <div class="terms_editor">
                <terms-component :termsType="termsType"></terms-component>
        </div>
      <button class="terms_btn" @click="close()"> 확인</button>
    </modal>

</template>

<script>
    import TermsComponent from "@/components/terms/TermsComponent";
    export default {
        name: "TermsModal",
        mixins: [],
        components: {
            TermsComponent
        },
        props: {

        },
        data() {
            return {
                termsType:''
            }
        },
        beforeRouterEnter() {},
        created() {
            //EventBus.$on
        },
        mounted() {
            //EventBus.$on('')
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods:{
            handlerBeforeOpen(event) {
                this.termsType = event.params.termsType;
            },
            handlerOpened() {
            },
            handlerBeforeClose() {
            },
            close(){
                this.$modal.hide('terms-modal');

            },
            returnTermsName(){
                if(this.termsType === 'stipulation'){
                    return '서비스이용약관'
                }if(this.termsType === 'privacy'){
                    return '개인정보처리방침'
                }
            }
        },
        watch: {

        },
    }
</script>

<style lang="scss">

</style>